module.exports = __webpack_public_path__ + "img/e-xiongwei-nan.ab02e52c.jpg";